import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";

const DataUsageTrend = () => {
  const [chartData, setChartData] = useState({ series: [], options: {} });
  const usageStatistics = useSelector(
    (state) => state.UsageStatistcs.usageStatistics
  );

  useEffect(() => {
    processData();
  }, [usageStatistics]);

  const processData = () => {
    // Group data by UOM
    const groupedByUom = {};
    if (usageStatistics) {
      usageStatistics?.forEach((item) => {
        if (!groupedByUom[item?.uom]) {
          groupedByUom[item?.uom] = [];
        }
        groupedByUom[item?.uom].push(item);
      });
    }

    // Prepare series data
    const series = [];
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Define display names and colors for each UOM
    const uomConfig = {
      MB: { name: "Data (MB)", color: "#FF6B6B" },
      BYTES: { name: "Data (BYTES)", color: "#4ECDC4" },
      OCCURRENCE: { name: "SMS", color: "#95E1D3" },
    };

    Object.keys(groupedByUom).forEach((uom) => {
      const resources = groupedByUom[uom];

      // Sum up usage across all resources for each month
      const monthlyData = Array(6).fill(0);

      resources.forEach((resource) => {
        resource.monthlyBreakup.forEach((monthData, index) => {
          monthlyData[index] += monthData.usage;
        });
      });

      const config = { name: uom, color: "#999999" };

      series.push({
        name: config.name,
        data: monthlyData,
      });
    });

    // Get categories (month names) from the first resource
    const categories = usageStatistics?.[0]?.monthlyBreakup?.map(
      (item) => monthNames[item?.month - 1]
    );

    const options = {
      chart: {
        type: "line",
        height: 350,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        width: 3,
        curve: "smooth",
      },
      markers: {
        size: 6,
        strokeWidth: 0,
        hover: {
          size: 8,
        },
      },
      xaxis: {
        categories: categories,
        labels: {
          style: {
            colors: "#999",
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: "#999",
            fontSize: "12px",
          },
          formatter: function (val) {
            return val.toFixed(0);
          },
        },
      },
      colors: ["#FF7A45", "#00c0d6", "#8a63ff"],
      legend: {
        position: "bottom",
        show: true,
        showForSingleSeries: true,
        horizontalAlign: "center",
        fontSize: "14px",
        markers: {
          width: 10,
          height: 10,
        },
      },
      grid: {
        borderColor: "#f1f1f1",
        strokeDashArray: 4,
      },
      tooltip: {
        y: {
          formatter: function (val, opts) {
            const seriesName = opts.w.globals.seriesNames[opts.seriesIndex];
            if (seriesName.includes("MB") || seriesName.includes("BYTES")) {
              return val.toFixed(2);
            }
            return val.toFixed(0);
          },
        },
      },
    };

    setChartData({ series, options });
  };

  return (
    <div
      className="card shadow-sm"
      style={{
        backgroundColor: "#F8FAFC",
        border: "1px solid #E2E8F0",
        borderRadius: "10px",
      }}
    >
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <CardTitle tag="h5" className="mb-1">
              Data Usage Trend
            </CardTitle>
            <small className="text-muted">Last 6 months</small>
          </div>

          <span className="rv-text-primary-color">
            {" "}
            <i
              className="mdi mdi-trending-up"
              style={{ color: "#FF7A45", fontSize: "20px" }}
            ></i>{" "}
            Monthly
          </span>
        </div>
        {chartData.series.length > 0 ? (
          <Chart
            options={chartData.options}
            series={chartData.series}
            type="line"
            height={300}
          />
        ) : (
          <div
            className="text-center d-flex justify-content-center align-items-center"
            style={{ height: 315 }}
          >
            <p className="fw-bold fs-5 balance-heading-color m-0">
              {"No Usage Data"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DataUsageTrend;
